import { useEffect, useRef, useState } from 'react'
import { ApiGetCallAuthKey, ApiGetCDNData, ApiPostCallAuthKey } from '../../JS/Connector';
import { capitaliseFirstWord, formatDecimal, HideLoder, isValidEmail, MMDDYYYY, ShowLoder } from '../../JS/Common';
import { CheckValidation } from '../../Components/Validations';
import ReCAPTCHA from 'react-google-recaptcha';
import AlertsComp from '../../Components/AlertsComp';
import StaticContent from './ContractPages/StaticContent';
import useConfig from '../../Hooks/useConfig';
import AlertPopup from '../../Components/AlertPopup';
import { log } from '../../JS/Logger';

function Contract() {
    const { student, organization, primary_text, logo, parent_manager, school, dcc_module_text,
        small_student } = useConfig();
    const pathname = window.location.pathname;
    const pathArray = pathname.split('/');
    const schoolnumber = pathArray[3];
    var captchasitekey = process.env.REACT_APP_Captcha_Sitekey;
    const recaptcharef = useRef();

    const [AllPlanName, setAllPlanName] = useState([]);
    const [PolicyAgreeFlag, setPolicyAgreeFlag] = useState(0)
    const [TermsAgreeFlag, setTermsAgreeFlag] = useState(0)
    const [UncoveredPrice, setUncoveredPrice] = useState("")
    const [insurancepolicyPdf, setinsurancepolicyPdf] = useState(null)
    const [purchaseYesPlanFlag, setPurchaseYesPlanFlag] = useState(1)
    const [SchoolId, setSchoolId] = useState('')
    const [SchoolName, setSchoolName] = useState('')
    const [planGrades, setPlanGrades] = useState([])
    const [planGradeVal, setplanGradeVal] = useState('')
    const [PlanStatusFlag, setPlanStatusFlag] = useState('')
    const [Description, setDescription] = useState('')
    const [Loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [AccessCode, setAccessCode] = useState('')
    const [ErrormsgFormidYear, setErrormsgFormidYear] = useState("");
    const [agreeFlagError, setAgreeFlagError] = useState("");
    const [agreeFuaFlagError, setAgreeFuaFlagError] = useState("");
    const [isStatusPopup, setIsStatusPopup] = useState(false)
    const [studentData, setStudentData] = useState({
        studentnum: '',
        firstname: "",
        lastname: '',
        parentfirstname: '',
        parentlastname: '',
        phoneno: '',
        email: '',
        isFormEditable: true,
        newStudent: false
    });
    const [toCompareData, setToCompareData] = useState({
        studentnum: '',
        firstname: "",
        lastname: '',
        parentfirstname: '',
        parentlastname: '',
        phoneno: '',
        email: ''
    });
    const [Emailerror, setEmailrror] = useState("")
    const [Enrollerror, setEnrollerror] = useState("")
    const [CutPriceFlag, setCutPriceFlag] = useState("");
    const [ActualPrice, setActualPrice] = useState('');
    const [totalPrice, setTotalPrice] = useState(0);
    const [showDetailsForm, setShowDetailsForm] = useState(false);
    const [SchoolLogo, setSchoolLogo] = useState('')

    const [termsClicked, setTermsClicked] = useState(false);
    const [policyClicked, setPolicyClicked] = useState(false);
    const [flashTerms, setFlashTerms] = useState(false);
    const [flashPolicy, setFlashPolicy] = useState(false);
    const [registrationDate, setregistrationDate] = useState('');
    const [planData, setPlanData] = useState({})
    const [ErrorMsg, setErrorMsg] = useState('')
    const [smallLoder, setSmallLoder] = useState(false)
    const [showForm, setShowForm] = useState(false)
    useEffect(() => {
        ApiGetCallAuthKey(`/schools/by-number?schoolNumber=${schoolnumber}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setSchoolId(responseRs?.msg?.id)
                    setSchoolLogo(responseRs?.logo)
                    setSchoolName(responseRs?.msg?.name)
                    setinsurancepolicyPdf(responseRs?.msg?.insurance_policy)
                    setDescription(
                        responseRs?.msg?.insurance_notes ||
                        `A ${student} ID number is assigned by your ${organization} district. Locate this number on your ${small_student}'s ${organization} ID card or recent report card. If you have issues, contact the district’s main office.`
                    )
                    setregistrationDate(responseRs?.coverage_end_date)
                    ApiGetCallAuthKey(`/plans/insurance/parental-grades?schoolId=${responseRs?.msg?.id}`).then((result) => {
                        if (result == undefined || result == "") {
                            alert("Something went wrong");
                        } else {
                            const responseRs1 = JSON.parse(result);
                            setPlanGrades(responseRs1)
                        }
                    });
                }
            }
        });
    }, []);

    async function GetLiveAllPlanCall(grade) {
        if (grade == "") {
            grade = null;
            setErrorMsg('');
            setAllPlanName([])
            setPlanData((prev) => ({ ...prev, flag: '' }));
            return;
        }
        setLoading(true);
        await ApiGetCallAuthKey(`/plans/insurance/live-by-school?schoolId=${SchoolId}&grade=${grade}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs2 = JSON.parse(result);
                setLoading(false);
                if (responseRs2.status == "success") {
                    if (responseRs2.data.length == 0) {
                        setPlanData((prev) => ({ ...prev, flag: '' }));
                        setAllPlanName([])
                    } else {
                        setErrorMsg('')
                        setAccessCode('')
                        setAllPlanName(responseRs2.data[0])
                        setUncoveredPrice(parseInt(responseRs2.data[0].uncovered_charge) > 0 ? responseRs2.data[0].uncovered_charge : null)
                        setPlanStatusFlag(responseRs2.data[0].plan_flag)
                        const currentDate = new Date();
                        const year = currentDate.getFullYear();
                        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                        const day = String(currentDate.getDate()).padStart(2, '0');
                        const formattedDate = `${year}-${month}-${day}`;
                        if (responseRs2?.flag == 3) {
                            setErrorMsg(responseRs2?.msg)
                        }
                        setTotalPrice(responseRs2.data[0].price)
                        setPlanData(responseRs2)
                    }
                } else {
                    setErrorMsg(responseRs2.msg)
                    setAllPlanName([])
                    setPlanData((prev) => ({ ...prev, flag: '' }));
                }
            }
        });
    }
    const openPDFInNewTab = () => {
        setPolicyClicked(true);
        setFlashPolicy(false);
        ApiGetCDNData("/" + insurancepolicyPdf, schoolnumber, SchoolId).then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
    };
    const openTermsInNewTab = () => {
        setTermsClicked(true);
        setFlashTerms(false);
        ApiGetCDNData("/termsconditions.pdf", schoolnumber, SchoolId).then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });

    };
    const handleTermsCheckbox = (e) => {
        if (!termsClicked) {
            e.preventDefault();
            setFlashTerms(true);
            // setTimeout(() => setFlashTerms(false), 1000);
        } else {
            setTermsAgreeFlag(e.target.checked ? 1 : 0);
        }
    };
    const handlePolicyCheckbox = (e) => {
        if (!policyClicked) {
            e.preventDefault();
            setFlashPolicy(true);
            // setTimeout(() => setFlashPolicy(false), 1000);
        } else {
            setPolicyAgreeFlag(e.target.checked ? 1 : 0);
        }
    };
    function calculateProratedCost(Price) {
        const enrollmentDate = new Date(AllPlanName.start_date);
        const actualPrice = Price;
        const PlanYear = enrollmentDate.getFullYear();
        const nextYearCutoffDate = new Date(PlanYear + 1, 0, 1);
        var proratedCost = 0;
        const currentDate = new Date();
        if (enrollmentDate > nextYearCutoffDate || currentDate > nextYearCutoffDate) {
            proratedCost = actualPrice * 0.60;
            setCutPriceFlag(1)
        } else {
            proratedCost = actualPrice;
        }
        setTotalPrice(proratedCost)
    }
    async function handleMidYearAccessCode() {
        var isFormValid = CheckValidation({ formID: 'midyeardiv' });
        if (!isFormValid) return;
        setSmallLoder(true);
        var raw = JSON.stringify({
            schoolId: SchoolId,
            studentNumber: studentData.studentnum,
            planId: AllPlanName.id,
            accessCode: AccessCode,
        });
        await ApiPostCallAuthKey("/plans/insurance/verify-access-code", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const ResponseRs = JSON.parse(result)
                if (ResponseRs.status == "success") {
                    setPlanData((prev) => ({ ...prev, flag: 1 }));
                    setActualPrice(totalPrice);
                    calculateProratedCost(totalPrice);
                    setErrorMsg('')
                    setSmallLoder(false);
                }
                else {
                    setSmallLoder(false);
                    setErrorMsg(ResponseRs.msg)
                    setPlanData((prev) => ({ ...prev, flag: 2 }));
                }
            }
        });
    }
    function checkFormValidation() {
        var isFormValid = CheckValidation({ formID: 'signUpForm' });
        if (!isValidEmail(studentData.email)) {
            setEmailrror("*Invalid Email");
            isFormValid = false;
        } else {
            setEmailrror("");
        }
        if (purchaseYesPlanFlag == 3) {
            setEnrollerror("*required");
            isFormValid = false;
        } else {
            setEnrollerror("");
        }
        if (!isFormValid) return;
        setShowDetailsForm(true)
        return isFormValid;
    }

    async function handleFinalSaveCall() {
        var isFormValid = checkFormValidation();
        let IsModified = 0
        if (toCompareData.firstname != studentData.firstname || toCompareData.lastname != studentData.lastname || toCompareData.email != studentData.email || toCompareData.parentfirstname != studentData.parentfirstname || toCompareData.parentlastname != studentData.parentlastname || toCompareData.phoneno != studentData.phoneno || studentData.newStudent) {
            IsModified = 1
        }
        if (TermsAgreeFlag == 0) {
            setAgreeFlagError("*required");
            isFormValid = false;
        } else {
            setAgreeFlagError("");
        }
        if (insurancepolicyPdf) {
            if (PolicyAgreeFlag == 0) {
                setAgreeFuaFlagError("*required");
                isFormValid = false;
            } else {
                setAgreeFuaFlagError("");
            }
        }

        if (!isFormValid) return;
        setLoading(true);
        const token = await recaptcharef.current.executeAsync();
        var raw = JSON.stringify({
            schoolId: SchoolId,
            studentFirstName: studentData.firstname,
            studentLastName: studentData.lastname,
            parentFirstName: studentData.parentfirstname,
            parentLastName: studentData.parentlastname,
            phoneNumber: studentData.phoneno,
            email: studentData.email,
            grade: planGradeVal,
            studentNumber: studentData.studentnum,
            total: purchaseYesPlanFlag == 1 ? totalPrice ? formatDecimal(totalPrice) : '0' : 0,
            planId: AllPlanName.id,
            captcha: token,
            coveragePurchased: purchaseYesPlanFlag == 1 ? 1 : 0,
            flag: PlanStatusFlag,
            isModified: IsModified,
            policyAgreeFlag: PolicyAgreeFlag
        });
        await ApiPostCallAuthKey("/plans/insurance/validate-json", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    if (purchaseYesPlanFlag == 1) {
                        const TRUSTED_RECEIPT_ORIGINS = ['https://dashboard.stripe.com', 'https://pay.stripe.com', 'https://checkout.stripe.com'];
                        try {
                            const parsed = new URL(responseRs.url);
                            if (TRUSTED_RECEIPT_ORIGINS.some(o => parsed.origin === o)) {
                                window.location.href = responseRs.url;
                            } else {
                                alert(`Untrusted redirect blocked: ${responseRs?.url}`);
                            }
                        } catch (err) { log.error(err) }
                        // window.location.href = responseRs.url;
                    } else {
                        handleSaveStudent(responseRs.temp_id);
                    }
                }
                else {
                    recaptcharef.current.reset();
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    const handleSaveStudent = async (TempId) => {
        var raw = JSON.stringify({
            tempId: TempId,
        });
        setLoading(true)
        await ApiPostCallAuthKey("/plans/insurance/purchase", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={`${student} Added Successfully`} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        window.location.reload();
                    }, 1500);
                }
                else {
                    alert('something went wrong')
                }
            }
        });
    }
    const getStudentData = async () => {
        const validate = CheckValidation({ formID: 'signUpForm' });
        if (!validate) { return; }
        setLoading(true)
        await ApiGetCallAuthKey(`/students/by-number?studentNumber=${studentData.studentnum}&schoolId=${SchoolId}`).then((result) => {

            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    if (responseRs?.data) {
                        const parentNameParts = responseRs.data.parent_guardian_name ? responseRs.data.parent_guardian_name.split(' ') : [];
                        const parentFirstName = parentNameParts[0] || "";
                        const parentLastName = parentNameParts[1] || "";
                        setStudentData({
                            ...studentData,
                            firstname: capitaliseFirstWord(responseRs?.data?.device_user_first_name),
                            lastname: capitaliseFirstWord(responseRs?.data?.device_user_last_name),
                            parentfirstname: capitaliseFirstWord(parentFirstName),
                            parentlastname: capitaliseFirstWord(parentLastName),
                            phoneno: responseRs?.data?.parent_phone_number || "",
                            email: responseRs?.data?.parent_guardian_email,
                            isFormEditable: !parentFirstName || !parentLastName || !responseRs?.data?.parent_guardian_email ? true : false,
                            newStudent: false

                        })
                        setToCompareData({
                            ...toCompareData,
                            firstname: capitaliseFirstWord(responseRs?.data?.device_user_first_name),
                            lastname: capitaliseFirstWord(responseRs?.data?.device_user_last_name),
                            parentfirstname: capitaliseFirstWord(parentFirstName),
                            parentlastname: capitaliseFirstWord(parentLastName),
                            phoneno: responseRs?.data?.parent_phone_number || "",
                            email: responseRs?.data?.parent_guardian_email,
                        })
                    } else {
                        setStudentData({
                            ...studentData,
                            firstname: "",
                            lastname: '',
                            parentfirstname: '',
                            parentlastname: '',
                            phoneno: '',
                            email: '',
                            isFormEditable: true,
                            newStudent: true
                        })
                        setToCompareData({
                            ...toCompareData,
                            firstname: "",
                            lastname: '',
                            parentfirstname: '',
                            parentlastname: '',
                            phoneno: '',
                            email: '',
                        })
                        // setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                        // setTimeout(() => {
                        //     setNewAlerts(<AlertsComp show={false} />)
                        // }, 1500);
                    }

                    setShowForm(true);
                }
                else {
                    alert('something went wrong')
                }
            }
        });
    }

    return (
        <div>
            <AlertPopup isshow={isStatusPopup} img={'/images/greenInfo.svg'}
                headingtext={`If you edit your information, it will be sent for admin approval. Do you want to continue?`}
                cancelcall={(e) => setIsStatusPopup(false)}
                canceltext={"No"} successtext={"Yes"} successcall={() => { setIsStatusPopup(false); setStudentData({ ...studentData, isFormEditable: !studentData.isFormEditable }) }} btntype={'SaveBtn'} />
            {NewAlerts}
            {Loading ? <ShowLoder /> : <HideLoder />}
            <div className="row">
                <div className="col-md-10 offset-md-1">
                    <div className={`${window.innerWidth >= 767 ? 'm-3 px-1' : ''} `}>
                        <div className={`${window.innerWidth >= 767 ? 'GridBox p-4  px-5 m-auto mx-5' : 'GridBox p-4 px-5 m-auto'} pb-5`}>
                            <StaticContent SchoolLogo={SchoolLogo} SchoolName={SchoolName} registrationDate={registrationDate} />
                            <div className='row mt-4 parent' id="signUpForm">
                                <div className='col-md-10 offset-md-1 py-3'>
                                    <div className='col-md-12 text-center'>
                                        <h4 className='fw-600 primary-text'>Let’s Get Started</h4>
                                        <label className='fw-600 pt-2 secondary-text'>Select your {small_student}’s grade for the upcoming {school} year.</label>
                                    </div>
                                    <div className='text-center secondary-text pb-3 col-md-4 offset-md-4'>
                                        <div className="secondary-text ms-2 py-1 pe-0">
                                            <select required value={planGradeVal} disabled={showDetailsForm}
                                                onChange={(e) => { setShowForm(false); setplanGradeVal(e.target.value); GetLiveAllPlanCall(e.target.value); }}>
                                                <option value="">Filter by Grade</option>
                                                {planGrades.map((item, j) => (
                                                    <option value={item} key={j}>
                                                        {item}
                                                    </option>
                                                ))}
                                            </select>
                                            <span className="form-text invalid-feedback">
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                    <div className={`p-3 row GridBox`}>
                                        <div className='col-md-6'>
                                            Club : <label className='fw-600 schoolColorStatus'>{AllPlanName.plan_name || '-'}</label>
                                        </div>
                                        <div className='col-md-6 text-end pt-2'>
                                            Prices : <label className='fw-600'>${AllPlanName.price || 0}</label>
                                        </div>
                                        <div className='col-md-6'>
                                            Sign Up Start Date: : <label className='fw-600'>{AllPlanName.start_date ? MMDDYYYY(AllPlanName.start_date) : '-'}</label>
                                        </div>
                                        <div className='col-md-6 text-end pt-2'>
                                            Sign Up End Date: : <label className='fw-600'>{AllPlanName.end_date ? MMDDYYYY(AllPlanName.end_date) : '-'}</label>
                                        </div>
                                    </div>

                                    {planData?.flag == 1 && (
                                        <>

                                            <div className='pt-3 secondary-text' >
                                                <div className='row'>
                                                    <div className='col-12 py-4'>
                                                        <label className='fw-600'>How to find the {student} number?  :</label>
                                                        <label className='redText font-12'>{Description || '-'}</label>
                                                    </div>
                                                    {AccessCode == AllPlanName?.access_token && (
                                                        <div className="col-md-6">
                                                            <div className='col-12 text-start'>Enter Access Code provided by the {organization} * </div>
                                                            <input type="text" autoComplete='off' placeholder='Enter Access Code' name='City' required className="form-control"
                                                                value={AccessCode} disabled onChange={(e) => { setAccessCode(e.target.value) }} />
                                                            <span className="form-text invalid-feedback">  *required </span>
                                                        </div>
                                                    )}
                                                    <div className="col-md-12 mt-3">
                                                        <label className='FormLabel'>{student} No.*</label>
                                                        <div className="row">
                                                            <div className="col-md-6 align-content-end">

                                                                <input className="form-control" required autoComplete="off" type="text" placeholder={`${student} No.`} name="studentnum"
                                                                    value={studentData.studentnum} disabled={showDetailsForm}
                                                                    onChange={(e) => { setShowForm(false); setStudentData({ ...studentData, studentnum: e.target.value.toUpperCase() }) }}
                                                                />

                                                                <span className="form-text invalid-feedback">
                                                                    *required
                                                                </span>
                                                            </div>
                                                            <div className="col-md-6 align-content-start">
                                                                <button className='SaveBtn px-3' disabled={showDetailsForm} onClick={() => { getStudentData() }}>Search</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {showForm &&
                                                (
                                                    <>
                                                        {studentData?.newStudent ? <div className='pt-3'><b className='custom-text-danger'>{student} data with the entered {small_student} number was not found. You can either try a different {small_student} number or you can enter new {small_student} details below:</b> </div> :
                                                            <div className='d-flex align-items-center pt-3'>
                                                                <b>{student} Details:</b>
                                                            </div>}
                                                        {!studentData?.isFormEditable ? <div>
                                                            <div className={`p-3 row GridBox`}>
                                                                <div className='col-md-6'>
                                                                    {student} First Name : <label className='fw-600'>{studentData.firstname || '-'}</label>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    {student} Last Name : <label className='fw-600'>{studentData.lastname || '-'}</label>
                                                                </div>
                                                                <div className='col-md-6 pt-2'>
                                                                    {parent_manager} First Name : <label className='fw-600'>{studentData.parentfirstname || '-'}</label>
                                                                </div>
                                                                <div className='col-md-6 pt-2'>
                                                                    {parent_manager} Last Name : <label className='fw-600'>{studentData.parentlastname || '-'}</label>
                                                                </div>
                                                                <div className='col-md-6 pt-2'>
                                                                    {parent_manager} Phone # : <label className='fw-600'>{studentData.phoneno || '-'}</label>
                                                                </div>
                                                                <div className='col-md-6 pt-2'>
                                                                    {parent_manager} Email : <label className='fw-600'>{studentData.email || '-'}</label>
                                                                </div>
                                                            </div>
                                                        </div> : <div className='text-start secondary-text py-3 row'>
                                                            <div className="col-md-4">
                                                                <label className='FormLabel'>{student} First Name*</label>
                                                                <input type="text" autoComplete='off' required name='firstname' className="form-control" placeholder='First Name' disabled={!studentData.isFormEditable}
                                                                    value={studentData.firstname} onChange={(e) => { setStudentData({ ...studentData, firstname: capitaliseFirstWord(e.target.value) }) }} />
                                                                <span className="form-text invalid-feedback">
                                                                    *required
                                                                </span>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className='FormLabel'>{student} Last Name*</label>

                                                                <input type="text" autoComplete='off' name='lastname' required className="form-control" placeholder='Last Name' disabled={!studentData.isFormEditable}
                                                                    value={studentData.lastname} onChange={(e) => { setStudentData({ ...studentData, lastname: capitaliseFirstWord(e.target.value) }) }} />
                                                                <span className="form-text invalid-feedback">
                                                                    *required
                                                                </span>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className='FormLabel'>{parent_manager} First Name*</label>

                                                                <input type="text" autoComplete='off' name='pfname' required className="form-control" placeholder='First Name' disabled={!studentData.isFormEditable}
                                                                    value={studentData.parentfirstname} onChange={(e) => { setStudentData({ ...studentData, parentfirstname: capitaliseFirstWord(e.target.value) }) }} />
                                                                <span className="form-text invalid-feedback"> *required </span>
                                                            </div>
                                                            <div className="col-md-4 pt-3">
                                                                <label className='FormLabel'>{parent_manager} Last Name*</label>

                                                                <input type="text" autoComplete='off' name='plname' required className="form-control" placeholder='Last Name' disabled={!studentData.isFormEditable}
                                                                    value={studentData.parentlastname} onChange={(e) => { setStudentData({ ...studentData, parentlastname: capitaliseFirstWord(e.target.value) }) }} />
                                                                <span className="form-text invalid-feedback">  *required  </span>
                                                            </div>
                                                            <div className={`col-md-4 pt-3`}>
                                                                <label className='FormLabel'>{parent_manager} Phone #</label>
                                                                <input type="text" autoComplete='off' placeholder='xxxxxxxxxx' name='contact' className="form-control" disabled={!studentData.isFormEditable}
                                                                    value={studentData.phoneno} onChange={(e) => {
                                                                        const re = /^[0-9\b]+$/;
                                                                        if (e.target.value === '' || re.test(e.target.value)) {
                                                                            setStudentData({ ...studentData, phoneno: e.target.value });
                                                                        }
                                                                    }} />
                                                            </div>
                                                            <div className={`col-md-4 pt-3`}>
                                                                <label className='FormLabel'>{parent_manager} Email *</label>
                                                                <input type="text" autoComplete='off' placeholder='Email' name='email' className="form-control" disabled={!studentData.isFormEditable}
                                                                    value={studentData.email} onChange={(e) => { setStudentData({ ...studentData, email: e.target.value }) }} />
                                                                <span className="Emailinvalid">{Emailerror}</span>
                                                            </div>

                                                            <div>

                                                            </div>
                                                            <span className="Emailinvalid">{Enrollerror}</span>
                                                        </div>}
                                                        <div className='col-md-12 mt-4 d-flex align-items-center justify-content-start'>
                                                            <label className=' fw-600'>I choose to enroll in the {dcc_module_text}: </label>
                                                            <div className="form-check ms-3">
                                                                <input className="form-check-input" type="radio" name='purchase' id='purchaseyes'
                                                                    checked={purchaseYesPlanFlag === 1}
                                                                    onChange={(e) => { setPurchaseYesPlanFlag(1) }}
                                                                    disabled={showDetailsForm == true}
                                                                />
                                                                <label className="form-check-label" htmlFor='purchaseyes'>Yes</label>
                                                            </div>
                                                            <div className="form-check ms-3">
                                                                <input className="form-check-input" type="radio" name='purchase' value='no' id='purchaseno'
                                                                    checked={purchaseYesPlanFlag === 2}
                                                                    onChange={(e) => { setPurchaseYesPlanFlag(2) }}
                                                                    disabled={showDetailsForm == true}
                                                                />
                                                                <label className="form-check-label" htmlFor='purchaseno'>No</label>
                                                            </div>
                                                        </div>
                                                        {purchaseYesPlanFlag == 2 && (
                                                            <div className='redText py-2 text-center'>
                                                                {UncoveredPrice == null ?
                                                                    <label>Note: If your device breaks during the {organization} year, you will be charged the full cost of the repair.</label>
                                                                    :
                                                                    <label>Note: If your device breaks during the {organization} year, you will be charged the ${UncoveredPrice} unenrolled flat fee.</label>
                                                                }

                                                            </div>
                                                        )}
                                                        {!showDetailsForm &&
                                                            <div className='row justify-content-center'>
                                                                <button type='submit' className={`SaveBtn mt-3 mb-3 col-md-2`}
                                                                    onClick={checkFormValidation}>Continue</button>
                                                                {!studentData.isFormEditable && (
                                                                    <button onClick={() => { setIsStatusPopup(true) }} className={`BorderBtn mt-3 mb-3 col-md-2 ms-3`}
                                                                    >Modify Details</button>
                                                                )}
                                                            </div>
                                                        }
                                                    </>
                                                )}

                                        </>
                                    )}
                                    {planData?.flag == 2 &&
                                        <>
                                            <div className='row parent' id="midyeardiv" >
                                                <label className='text-center font-14 pt-3 fw-600' style={{ color: '#ec7518' }}>{dcc_module_text} is active, but the sign-up date has passed. Please enter your Mid-Year Access Code to proceed.</label>
                                                <div className="col-md-6 pb-3 pt-4 offset-md-3">
                                                    <div className='col-12 text-start px-1 pb-1 fw-600'>Enter Access Code provided by the {organization} * </div>
                                                    <input type="text" autoComplete='off' placeholder='Enter Access Code' name='City' required className="form-control"
                                                        value={AccessCode} onChange={(e) => { setAccessCode(e.target.value) }} />
                                                    <span className="form-text invalid-feedback">  *required </span>
                                                </div>
                                                <div className='redText'>{ErrormsgFormidYear}</div>
                                                <div className='text-center d-flex my-2 justify-content-center'>
                                                    {smallLoder == true && (<img src="/images/loder.svg" className="mx-1" style={{ width: "30px" }} />)}
                                                    <button className='SaveBtn mx-2 px-4' onClick={(e) => handleMidYearAccessCode(e)}>Verify</button>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {ErrorMsg && (
                                        <label className="text-center d-flex justify-content-center font-14 py-2" style={{ color: "var(--error_text_color)" }}>{ErrorMsg}</label>
                                    )}
                                    {showDetailsForm == true && showForm &&
                                        <>
                                            {purchaseYesPlanFlag == 1 &&
                                                <div className='col-12 text-center'>
                                                    <label className='signup-font'>CLUB PRICE</label>&nbsp;&nbsp;&nbsp;
                                                    <label className='font-18'>
                                                        <b style={{ color: '#4f4f4f' }}>
                                                            {CutPriceFlag == 1 && (
                                                                <label className={`${ActualPrice != '' ? '' : 'd-none'} grayColor pe-2`}>
                                                                    <strike>${ActualPrice ? formatDecimal(ActualPrice) : 0}</strike>
                                                                </label>
                                                            )}
                                                            ${totalPrice ? formatDecimal(totalPrice) : '0'}
                                                        </b>
                                                    </label>
                                                    {CutPriceFlag == 1 && (
                                                        <div className="col-12 m-0 mt-2 zoom-in-out-box ">
                                                            <span className="signuplink font-13">Since your enrollment is after January 1st, your cost has been adjusted to 60% of the standard rate. </span>
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                            <>
                                                <div className="col-md-4 offset-md-4 text-center pb-2">
                                                    <div className="d-flex justify-content-center my-3">
                                                        <ReCAPTCHA ref={recaptcharef} sitekey={captchasitekey} size="invisible" />
                                                    </div>
                                                </div>
                                                <div className='secondary-text py-3'>
                                                    <label>
                                                        Please click and review {primary_text}'s &nbsp;
                                                        <u className={`cursor-pointer ${flashTerms ? 'flash-link' : ''}`}
                                                            style={{ color: "#04ADFD", fontWeight: "600" }}
                                                            onClick={openTermsInNewTab}>
                                                            Terms and Conditions
                                                        </u>
                                                        {insurancepolicyPdf != null && (
                                                            <>
                                                                &nbsp;and {SchoolName}'s&nbsp;
                                                                <u className={`cursor-pointer ${flashPolicy ? 'flash-link' : ''}`}
                                                                    style={{ color: "#04ADFD", fontWeight: "600" }}
                                                                    onClick={openPDFInNewTab}>
                                                                    Fair Use Policy
                                                                </u>
                                                            </>
                                                        )}
                                                        . Acknowledgment is required to continue, regardless of participation in the club.
                                                    </label>
                                                    <div className='row'>
                                                        <div className='col-12 d-flex align-items-center mt-3' style={{ color: "#4C5258", fontSize: "13px" }}>
                                                            <input
                                                                className='form-check-input mt-0 me-2 cursor-pointer'
                                                                type="checkbox"
                                                                checked={TermsAgreeFlag == 1}
                                                                onChange={handleTermsCheckbox}
                                                            />
                                                            <label> I have read and acknowledge {primary_text}'s Terms and Conditions. </label>
                                                        </div>
                                                        <span className='Emailinvalid'>{agreeFlagError}</span>
                                                        {insurancepolicyPdf != null && (
                                                            <div className='col-12 d-flex align-items-center mt-3' style={{ color: "#4C5258", fontSize: "13px" }}>
                                                                <input
                                                                    className='form-check-input mt-0 me-2 cursor-pointer'
                                                                    type="checkbox"
                                                                    checked={PolicyAgreeFlag == 1}
                                                                    onChange={handlePolicyCheckbox}
                                                                />
                                                                <label> I have read and acknowledge the district's Terms and Conditions.</label>
                                                            </div>
                                                        )}
                                                        <span className='Emailinvalid'>{agreeFuaFlagError}</span>
                                                        {flashTerms && <div className='mt-1 custom-text-danger'>*Please review the Terms & Conditions document before continuing.</div>}
                                                        {flashPolicy && <div className='mt-1 custom-text-danger'>*Please review the Fair Use Policy document before continuing.</div>}
                                                    </div>
                                                </div>
                                                <button type='submit' className='SaveBtn px-3 col-md-4 offset-md-4'
                                                    onClick={(e) => handleFinalSaveCall()}>
                                                    {purchaseYesPlanFlag == 1 ? "Proceed to Payment" : "Submit Acknowledgement"}
                                                </button>
                                                <label className="my-4 ps-3 text-center cursor-pointer">
                                                    <u onClick={(e) => window.location.reload()}>Cancel</u>
                                                </label>
                                                {purchaseYesPlanFlag == 1 &&
                                                    <div className='col-12 text-center mt-2'>
                                                        <span className="font-13 contentClr">  Powered by <img src='/images/stripeIcon.svg' className='img-fluid ' />   </span>
                                                    </div>
                                                }
                                            </>
                                        </>
                                    }
                                </div>
                            </div>

                            {planGradeVal != '' && (
                                <div className='col-12 text-center px-0  pt-4 secondary-text'>
                                    If you have any questions about our agreement, please don't hesitate to <span className='whats-cover-text fw-600 cursor-pointer' onClick={(e) => window.open(`/contact-us/${SchoolId}/${AllPlanName.id}`, 'blank')}><u>contact us</u></span>.
                                </div>
                            )}
                            <div className="col-12 pt-3 pb-5 text-center">
                                <img
                                    src={logo}
                                    className="img-fluid"
                                    alt="Logo"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Contract
